export default __webpack_public_path__ + "static/media/art-fa.546bec64.jpg";